<div class="toolbar-wrapper">
  <app-toolbar></app-toolbar>
</div>

<main class="outlet-wrapper">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>

